module.exports = __webpack_public_path__ + "static/media/my-no-data.47a831a9.svg";